<template>
  <v-container fluid class="savitarna-toolbar ">
    <div v-html="content" />
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import headerData from './headerData'
import request from '@/util/savitarnaMenu'
import { Neigalieji } from '../../../assets/neigalieji.js'

export default {
  name: 'SavToolbar',
  mixins: [headerData],
  data() {
    return {
      content: null,
      aliveTimer: null,
      aliveTimeout: 60000,
    }
  },
  computed: {
    ...mapGetters(['savitarnaXid']),
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
  },
  beforeCreate() {
    this.$root.$off(`updateSavToolbar`)
  },
  created() {
    window.NeigaliSavitarna = this.changeNeigalieji.bind(this)
    this.getData(true)
    this.$root.$on(`updateSavToolbar`, () => {
      this.getData()
    })
  },
  methods: {
    getData(first = false) {
      if (!this.isLocal) {
        request({
          url: `menu.do;jsessionid=${this.savitarnaXid}`,
          method: 'get',
        })
          .then(res => {
            let fullMenu = res.data
            if (!this.checkMenu(fullMenu)) {
              if (first) {
                window._VMA.$emit('SAV_LOGIN_ERROR')
              } else {
                window._VMA.$emit('SAV_SESSION_ERROR')
              }
              return
            }
            this.content = this.parseTopHeader(fullMenu)
            // this.content = this.parseNeigaliujuVersija(this.content)

            if (!this.aliveTimer) {
              this.aliveTimer = setInterval(() => {
                this.getData()
              }, this.aliveTimeout)
            }
            this.getKrepselisUrl(this.content)
            this.getSavitarnaHomeUrl(this.content)
            this.getBreadcrumbs(fullMenu)
            this.$emit('loaded')
          })
          .catch(err => {
            console.log(err)
            clearInterval(this.aliveTimer)
            this.aliveTimer = null
            if (!this.isLocal && first) {
              window._VMA.$emit('SAV_SESSION_ERROR')
            }
          })
      } else {
        if (this.isLocal) {
          this.content = this.parseTopHeader(this.menuData)
          this.content = this.parseNeigaliujuVersija(this.content)
          //this.getKrepselisUrl(this.content)
          //this.getSavitarnaHomeUrl(this.content)
          this.getBreadcrumbs(this.menuData)
          this.$emit('loaded')
        } else {
          clearInterval(this.aliveTimer)
          this.aliveTimer = null
          window._VMA.$emit('SAV_SESSION_ERROR')
        }
      }
    },
    checkMenu(data) {
      return data.includes('<div id="info-panel">')
    },
    parseTopHeader(data) {
      let header = data
      header = header.replace(/^.*?(?=<div id="info-panel">)/s, '')
      header = header.replace(/(?=<div id="content-in">).*?$/s, '')
      return header
    },
    parseNeigaliujuVersija(data) {
      data = data.replace(
        /javascript:Neigal\(\)/,
        'javascript:NeigaliSavitarna()'
      )
      if (this.isLocal) {
        data = data.replace(
          /https:\/\/w2dev.kada.lt\/savitarna\/images\/icn-disa.png/,
          '/static/icn-disa.png'
        )
      }
      return data
    },
    getKrepselisUrl(data) {
      let subStart = data.indexOf('id="sav_basket"')
      if (subStart > 0) {
        let subEnd = data.indexOf('>', subStart)
        let subData = data.substring(subStart, subEnd)

        let urlRegex = /(https?:\/\/[^"]*)/
        let url = subData.match(urlRegex)[1].trim()

        this.$store.dispatch('savitarnaKrepselisUrl', url)
      }
    },
    getSavitarnaHomeUrl(data) {
      let subStart = data.indexOf('id="sav_rcLogo2"')
      if (subStart > 0) {
        let subEnd = data.indexOf('>', subStart)
        let subData = data.substring(subStart, subEnd)

        let urlRegex = /(https?:\/\/[^"]*)/
        let url = subData.match(urlRegex)[1].trim()

        this.$store.dispatch('savitarnaHomeUrl', url)
      }
    },
    getBreadcrumbs(data) {
      let crumbs = data
      if (crumbs) {
        crumbs = crumbs.replace(/^.*?(?=<ul class="path">)/s, '')
        crumbs = crumbs.replace(/(?=<div class="print-top">).*?$/s, '')
        crumbs = crumbs.replaceAll('\n', '')

        if (crumbs && crumbs.length > 0) {
          let result = []
          let ahref = crumbs
          // ahref = ahref.match(/<a[^>]+>(.*[^<\/a>]+)<\/a>/g)
          ahref = ahref.match(/<a[^<]+<\/a>/g)

          if (ahref && ahref.length > 0) {
            result = ahref.map(function(val) {
              let url = val.match(/(https?:\/\/[^"]*)/)[1].trim()
              let name = val.match(/>(.*[^<])<\/a>/)[1].trim()
              return { text: name, href: url, exact: true, disabled: false }
            })
          }
          this.$store.dispatch('savitarnaBreadcrumbs', result)
        }
      }
    },
    changeNeigalieji() {
      Neigalieji()
    },
  },
}
</script>

<style lang="scss">
.savitarna-toolbar {
  padding: 0;
  background: #fff;
}
#info-panel {
  height: 27px !important;
}
.site-info {
  margin-top: 5px !important;
}
</style>
